import ImageConverterTemplate from "../components/ImageConverterTemplate";
export default function ConvertJpgToJpeg() {
  return <ImageConverterTemplate sourceFormat="JPG" targetFormat="JPEG" acceptTypes=".jpg,.jpeg,image/jpeg" slug="convert-jpg-to-jpeg" gradientColors="from-orange-500 to-red-600" accentColor="orange" showQualitySlider={true} />;
}
